<template>
  <TemplateDashboardCopa />
</template>

<script setup>
import TemplateDashboardCopa from 'components/Template/TemplateDashboardCopa.vue'
</script>
